// window.onbeforeunload = function () {
//     window.scrollTo(0, 0);
// };

const initWorkProcessBlock = () => {
    // Select the element for animation
    const stepsWrapper = document.querySelector('.js-work-process-steps-wrapper');

    if (!stepsWrapper) {
        return;
    }

    if( window.innerWidth >= 1199) {
        // Register ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);

        // Apply GSAP animation with ScrollTrigger
        gsap.to(stepsWrapper, {
            scrollTrigger: {
                trigger: ".js-work-process-steps",
                start: "center center",
                end: "+=66%",
                scrub: true,
                pin: true,
                anticipatePin: 1, // Anticipates pinning for smoother transitions
                invalidateOnRefresh: true,
                refreshPriority: 1,
                onUpdate: (self) => {
                    const progress = self.progress;

                    // Update classes based on scroll progress
                    if (progress < 0.33) {
                        stepsWrapper.classList.add('step-1');
                        stepsWrapper.classList.remove('step-2', 'step-3');
                    } else if (progress < 0.66) {
                        stepsWrapper.classList.add('step-2');
                        stepsWrapper.classList.remove('step-1', 'step-3');
                    } else {
                        stepsWrapper.classList.add('step-3');
                        stepsWrapper.classList.remove('step-1', 'step-2');
                    }
                }
            }
        });

        // Refresh ScrollTrigger after page load to ensure correct positioning
        ScrollTrigger.refresh();
    }else {
        const processClickLinks = document.querySelectorAll('.js-process-click');

        if (processClickLinks.length > 0) { // Check if elements exist
            processClickLinks.forEach(paginationLink => {
                paginationLink.addEventListener('click', event => {
                    event.preventDefault(); // Prevent default link action

                    const stepNumber = paginationLink.getAttribute('data-number'); // Get step number

                    // Remove any existing 'step-' class
                    stepsWrapper.classList.forEach(className => {
                        if (className.startsWith('step-')) {
                            stepsWrapper.classList.remove(className);
                        }
                    });

                    // Add the new step class
                    stepsWrapper.classList.add(`step-${stepNumber}`);

                    // Update active class on pagination buttons
                    processClickLinks.forEach(link => {
                        link.classList.toggle('active', link === paginationLink);
                    });
                });
            });
        }
    }
    
};

document.addEventListener('DOMContentLoaded', initWorkProcessBlock, false)